import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';

import { TSupport } from './get-supports';

type TCreateSupport = {
  name: string;
};

const postSupport = (data: TCreateSupport): Promise<TSupport> => {
  return mediaManagerClient.post('/api/v1/supports', data);
};

export const usePostSupport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['supports'],
      });
    },
    mutationFn: postSupport,
  });
};
